module.exports = __webpack_public_path__ + "img/ساده-وگویا.41c046e7.png";